/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import TopHeader from '../../../../components/TopHeader';
import { Link, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../../../components/ErrorMessage';
import Loader from '../../../../components/Loader';
import GlobalContext from '../../../../components/Context/GloablContext';
import { passwordCriteria } from './passwordCriteria';
import { userService } from '../../../../services/user.services';
import { clearAuthData, broadcastLogout } from '../../../../CommonMethods/AuthSync';

const UpdatePassword = () => {
    const navigate = useNavigate();
    const [type, settype] = useState({
        temp_password: false,
        new_password: false,
        confirm_new_password: false
    });
    const [inputFields, setInputFields] = useState({
        temp_password: "",
        new_password: "",
        confirm_new_password: ""
    });
    const [loading, setLoading] = useState(false);
    const [Overallerror, setOverallerror] = useState({
        "dependant_error1": false,
        "dependant_error2": false,
        "temp_pass": '',
        "new_pass": '',
        "confirm_new_pass": ''
    });

    const [submitSelected, setSubmitSelected] = useState(false);

    const { setToastmessage } = useContext(GlobalContext);

    const handleShowPassword = (id) => {
        settype((prev) => ({
            ...prev,
            [id]: !type[id]
        }));
    };

    // Define a regular expression to allow specific special characters
    const allowedSpecialCharacters = /[!@#$%^&*():.=+\[\]{}<>]/;

    // Check if password is valid (must contain at least one allowed special character)
    const isPasswordValid = inputFields.new_password.trim() !== '' && allowedSpecialCharacters.test(inputFields.new_password);

    // Error message for disallowed special characters
    const disallowedSpecialCharsError = 'Password contains disallowed special characters';

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setSubmitSelected(true);
        setLoading(true);

        if (inputFields.temp_password.trim() === inputFields.new_password.trim()) {
            setOverallerror((prev) => ({ ...prev, dependant_error1: true, dependant_error2: false, temp_pass: '', new_pass: 'Current and new password cannot be same' }));
            setLoading(false);
            return;
        }
        if (inputFields.new_password.trim() !== inputFields.confirm_new_password.trim()) {
            setOverallerror((prev) => ({ ...prev, dependant_error2: true, dependant_error1: false, confirm_new_pass: 'Passwords do not match', new_pass: '' }));
            setLoading(false);
            return;
        }
        const payload = {
            "old_password": inputFields.temp_password,
            "new_password": inputFields.new_password,
            "confirm_password": inputFields.confirm_new_password,
            "type": "update"
        };
        const email = sessionStorage.getItem('email');
        const ResetResponse = await userService.resetPassword(email, payload);
        if (ResetResponse.error === false) {
            setToastmessage("Password updated successfully");
            setLoading(false);
            // Clear auth data from both sessionStorage and localStorage
            clearAuthData();
            // Broadcast logout to all tabs so they log out properly
            broadcastLogout();
            navigate('/');
        } else {
            setOverallerror((prev) => ({ ...prev, dependant_error2: false, dependant_error1: false, temp_pass: ResetResponse?.message?.response?.data?.message }));
            setLoading(false);
        }
    };

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={'Update Password'} />
                <div className='bg-white rounded-lg py-[16px] px-[30px] h-customh3'>
                    <div className='flex items-center mb-5'>
                        <Link to="/profile">
                            <h1 className="text-sm font-normal text-[#52555D]">Profile</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                        <h1 className="text-sm font-normal text-[#008586]">Update Password</h1>
                    </div>
                    <div className="flex items-center justify-between">
                        <Link to={'/profile'} className='flex items-center min-w-max'>
                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Profile</span>
                        </Link>
                    </div>
                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'> Update Your Password</h1>
                    <div className='flex items-center justify-center mt-[50px]'>
                        <div className='border py-[25px] px-[56px] flex justify-between'>
                            <div className='px-[65px]'>
                                <form action="" className='' onSubmit={(e) => handleResetPassword(e)}>
                                    <div className='flex flex-col mt-4'>
                                        <label htmlFor='temp_password' className='text-xs font-semibold text-[#000] pb-1.5'>Current Password*</label>
                                        <div className='relative'>
                                            <input type={type['temp_password'] ? "text" : "password"} id='temp_password'
                                                value={inputFields["temp_password"]}
                                                onFocus={() => {
                                                    setOverallerror((prev) => ({
                                                        ...prev,
                                                        dependant_error1: false,
                                                        dependant_error2: false,
                                                        temp_pass: '',
                                                        new_pass: '',
                                                        confirm_new_pass: ''
                                                    }));
                                                    setSubmitSelected(false);
                                                }}
                                                style={{ border: `1px solid ${submitSelected && (Overallerror.temp_pass !== '' || Overallerror.dependant_error1 && Overallerror.new_pass !== '') ? '#C81720' : '#C5C9DA'}` }}
                                                onChange={(e) => { setInputFields((prev) => ({ ...prev, "temp_password": (e.target.value).trim() })) }}
                                                className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                                font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                                focus:border-[#339D9E] focus:shadow-s1'
                                                autoComplete='off' placeholder='Enter current password' />
                                            <button type='button' onClick={() => handleShowPassword('temp_password')} className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                <span className='text-xs font-semibold text-[#008586]'>{type['temp_password'] ? "HIDE" : "SHOW"}</span>
                                            </button>
                                        </div>
                                    </div>
                                    {Overallerror.temp_pass !== '' && <ErrorMessage error message={Overallerror.temp_pass} />}
                                    <div className='flex flex-col mt-3'>
                                        <label htmlFor='new_password' className='text-xs font-semibold text-[#000] pb-1.5'>New Password*</label>
                                        <div className='relative'>
                                            <input type={type['new_password'] ? "text" : "password"} id='new_password'
                                                value={inputFields["new_password"]}
                                                onFocus={() => {
                                                    setOverallerror((prev) => ({
                                                        ...prev,
                                                        dependant_error1: false,
                                                        dependant_error2: false,
                                                        temp_pass: '',
                                                        new_pass: '',
                                                        confirm_new_pass: ''
                                                    }));
                                                    setSubmitSelected(false);
                                                }}
                                                style={{ border: `1px solid ${submitSelected && (Overallerror.new_pass !== '' || (Overallerror.dependant_error2 && Overallerror.confirm_new_pass) || Overallerror.dependant_error1) ? '#C81720' : '#C5C9DA'}` }}
                                                onChange={(e) => { setInputFields((prev) => ({ ...prev, "new_password": (e.target.value).trim() })) }}
                                                className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                                font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                                focus:border-[#339D9E] focus:shadow-s1'
                                                autoComplete='off' placeholder='Enter new password' />
                                            <button type='button' onClick={() => handleShowPassword('new_password')} className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                <span className='text-xs font-semibold text-[#008586]'>{type['new_password'] ? "HIDE" : "SHOW"}</span>
                                            </button>
                                        </div>
                                    </div>
                                    {Overallerror.new_pass !== '' && <ErrorMessage error message={Overallerror.new_pass} />}
                                    <div className='flex flex-col mt-3'>
                                        <label htmlFor='confirm_new_password' className='text-xs font-semibold text-[#000] pb-1.5'>Confirm New Password*</label>
                                        <div className='relative'>
                                            <input type={type['confirm_new_password'] ? "text" : "password"} id='confirm_new_password'
                                                value={inputFields["confirm_new_password"]}
                                                onFocus={() => {
                                                    setOverallerror((prev) => ({
                                                        ...prev,
                                                        dependant_error1: false,
                                                        dependant_error2: false,
                                                        temp_pass: '',
                                                        new_pass: '',
                                                        confirm_new_pass: ''
                                                    }));
                                                    setSubmitSelected(false);
                                                }}
                                                style={{ border: `1px solid ${submitSelected && (Overallerror.confirm_new_pass !== '' || (Overallerror.dependant_error2 && Overallerror.confirm_new_pass !== "")) ? '#C81720' : '#C5C9DA'}` }}
                                                onChange={(e) => { setInputFields((prev) => ({ ...prev, "confirm_new_password": (e.target.value).trim() })) }}
                                                className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                                font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                                focus:border-[#339D9E] focus:shadow-s1'
                                                autoComplete='off' placeholder='Enter new password' />
                                            <button type='button' onClick={() => handleShowPassword("confirm_new_password")} className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                <span className='text-xs font-semibold text-[#008586]'>{type['confirm_new_password'] ? "HIDE" : "SHOW"}</span>
                                            </button>
                                        </div>
                                    </div>
                                    {Overallerror.confirm_new_pass !== '' && <ErrorMessage error message={Overallerror.confirm_new_pass} />}
                                    <button type='submit'
                                        id="login"
                                        disabled={loading || !isPasswordValid || Object.values(inputFields).some(value => typeof value === 'string' && value.trim() === '')}
                                        className={`w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                                        ${loading || !isPasswordValid || Object.values(inputFields).some(value => typeof value === 'string' && value.trim() === '') ? 'bg-[#777C88]' : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'} `}>
                                        {!loading ? 'Update' : <span><Loader /></span>}
                                    </button>
                                </form>
                            </div>
                            <div className='border-l pl-[105px] pr-[35px]'>
                                <p className='text-lg font-bold text-[#000000] mb-2'>Password must have :</p>
                                <ul>
                                    {Object.keys(passwordCriteria).map((criteria, index) => (
                                        <li className={`mb-1.5 flex`} key={criteria}>
                                            <span className='pt-1'>
                                                <img src={(inputFields.new_password === '') ? `/images/password_failed.svg` : (!passwordCriteria[criteria]["regex"].test(inputFields['new_password']) && inputFields.new_password !== '') ? '/images/password_not_satisfied.svg' : "/images/password_satisfied.svg"} alt="icon" />
                                            </span>
                                            {/* text-[#1A883C] */}
                                            <span className={`text-[16px] font-normal ${(inputFields.new_password.trim() === '') ? 'text-[#000000]' : (!passwordCriteria[criteria]["regex"].test(inputFields['new_password']) && inputFields.new_password.trim() !== '') ? 'text-[#C81720]' : 'text-[#1A883C]'}  pl-1.5`}>
                                                {index == 4 ? <>{criteria.split('\n')[0]}<br />{criteria.split('\n')[1]}</> : criteria}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdatePassword;
